(function () {
	const sectionTabs = () => {
		const tabsSections = document.querySelectorAll(".testimonials");

		tabsSections.forEach((tabSection) => {
			const tabs = tabSection.querySelectorAll("[data-tab-target]");
			const tabContents = tabSection.querySelectorAll("[data-tab-content]");
			const prevArrow = tabSection.querySelector(".prev-arrow"); // Add your arrow selectors
			const nextArrow = tabSection.querySelector(".next-arrow");
			
			let maxContentHeight = 0;

			// Calculate maximum content height
			tabContents.forEach((tabContent) => {
				const originalDisplay = tabContent.style.display;
				tabContent.style.display = "block";
				let tabItemInfoBlock = tabContent.querySelector(".testimonials__item-block");

				if (tabItemInfoBlock.clientHeight > maxContentHeight) {
					maxContentHeight = tabItemInfoBlock.clientHeight;
				}

				tabContent.style.display = originalDisplay;
			});

			// Set minHeight for all content sections
			tabContents.forEach((tabContent) => {
				let tabItemInfoBlock = tabContent.querySelector(".testimonials__item-block");
				if (tabItemInfoBlock) {
					tabItemInfoBlock.style.minHeight = maxContentHeight + "px";
				}
			});

			// Handle tab click
			const handleTabClick = (tab) => {
				const targets = tabSection.querySelectorAll(`[data-tab-content="${tab.dataset.tabTarget}"]`);
				tabContents.forEach((tabContent) => {
					tabContent.classList.remove("active");
				});
				tabs.forEach((tab) => {
					tab.classList.remove("active");
				});
				tab.classList.add("active");
				targets.forEach((target) => {
					target.classList.add("active");
				});
			};

			// Handle arrow click
			const handleArrowClick = (direction) => {
				const newIndex = (currentIndex + (direction === "next" ? 1 : -1) + tabs.length) % tabs.length;
				handleTabClick(tabs[newIndex]);
				currentIndex = newIndex;
			};

			let currentIndex = 0;
			const slideInterval = 5000; // Interval in milliseconds (5 seconds)
			const autoSlide = () => {
				handleTabClick(tabs[currentIndex]);
				currentIndex = (currentIndex + 1) % tabs.length;
			};
			let slideTimer = setInterval(autoSlide, slideInterval);

			// Bind arrow events
			if (prevArrow) {
				prevArrow.addEventListener("click", () => handleArrowClick("prev"));
			}
			if (nextArrow) {
				nextArrow.addEventListener("click", () => handleArrowClick("next"));
			}

			// Reset auto-slide on user interaction
			tabs.forEach((tab) => {
				tab.addEventListener("click", () => {
					clearInterval(slideTimer);
					slideTimer = setInterval(autoSlide, slideInterval);
				});
			});

			// Stop auto-slide on mouseover
			tabSection.addEventListener("mouseover", () => clearInterval(slideTimer));

			// Resume auto-slide on mouseout
			tabSection.addEventListener("mouseout", () => {
				slideTimer = setInterval(autoSlide, slideInterval);
			});
		});
	};

	document.addEventListener("DOMContentLoaded", () => {
		sectionTabs();
	});

	document.addEventListener("shopify:section:load", () => {
		sectionTabs();
	});
})();
